import React, {useEffect, useState} from 'react';
import Table from "../../../../shared/ui/table/table/Table";
import {useSelector} from "react-redux";
import {selectSelectedPharmacist} from "../../../../core/reducer/auth/authSlice";
import {selectSelectedPharmacy} from "../../../../core/reducer/pharmacySlice";
import http from "../../../../shared/utils/http";
import {tableStructureEmployees} from "../EmployeeStructureData";




export function DisabledEmployees({templates}: any) {
    const [employees, setEmployees] = useState<any[]>([])
    const pharmacist = useSelector(selectSelectedPharmacist)
    const pharmacy = useSelector(selectSelectedPharmacy)
    useEffect(() => {
        pharmacist && pharmacy && http.get(`pharmacists/${pharmacist}/pharmacies/${pharmacy.idDocument}/employees/disabled`).then(r => {
            setEmployees(r.employees)
        })
    }, [pharmacist, pharmacy]);

    return (


                        <Table columns={tableStructureEmployees}
                               data={employees}
                               templates={templates}/>

    );
}


